/* jshint node:true */
  'use strict';

  module.exports = "\n";
  